import { IconButton } from '@mui/material';
import DarkModeOutlinedIcon from '@mui/icons-material/DarkModeOutlined';
import LightModeOutlinedIcon from '@mui/icons-material/LightModeOutlined';
import { useThemeMode } from '../../theme/ThemeModeProvider';

/**
 * Light or dark, and nothing else.
 *
 * **Two states rather than three.** A light / dark / system menu would put the
 * default on screen as a third thing to choose, when following the system is
 * simply what happens until somebody chooses.
 *
 * **The icon is the mode being offered, not the mode you are in**, which is
 * what every other app's toggle does — and why the label says "Switch to"
 * rather than naming the current theme.
 */
export const ThemeModeToggle = () => {
  const { mode, toggleMode } = useThemeMode();
  const isDark = mode === 'dark';

  return (
    <IconButton
      onClick={toggleMode}
      aria-label={isDark ? 'Switch to light theme' : 'Switch to dark theme'}
      aria-pressed={isDark}
      size="small"
    >
      {isDark ? (
        <LightModeOutlinedIcon fontSize="small" />
      ) : (
        <DarkModeOutlinedIcon fontSize="small" />
      )}
    </IconButton>
  );
};
